import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { compact } from "lodash"
import type { StateObject } from "../../../redux/types"
import type { UserAccount } from "../../../data/types"
import { getRecordEditId } from "../../../router/selectors"
import { getDataStateObject, getUserAccountById } from "../../../data/selectors"
import { getSelectedLocationIdsFromGlobalFilter } from "../../../filters/selectors"
import { TimesheetRecord } from "../../../../graphql/types"
import { getAuthStateObject } from "../../../auth/selectors"

export const filterEmployeeBySelectedLocations = (state: StateObject, u: UserAccount) => {
    const selectedLocationsIds = getSelectedLocationIdsFromGlobalFilter(state)
    if (!selectedLocationsIds) {
        return false
    }

    return (u.locationIds ?? []).some(l => selectedLocationsIds.includes(l))
}

export const getAuthEmployeeId = (state: StateObject): Maybe<string> => {
    const authUserId = getAuthStateObject(state).userId
    return getDataStateObject(state).userAccounts.find(uA => uA.userId === authUserId)?.id ?? null
}

export const getEditEmployeeId = (state: StateObject) => getRecordEditId(state)

export const getEditEmployee = (state: StateObject): Maybe<UserAccount> =>
    getUserAccountById(state, getEditEmployeeId(state))

export const getEmployeesPins = (state: StateObject): string[] => {
    const editEmployeeId = getEditEmployeeId(state)
    return compact(
        getDataStateObject(state)
            .userAccounts.filter(u => (editEmployeeId ? u.id !== editEmployeeId : true))
            .map(u => u.pin ?? null)
    )
}

export const getEmployeesIdsWithAccessCardKeys = (
    state: StateObject
): {
    id: string
    accessKey: string
}[] =>
    compact(
        getDataStateObject(state).userAccounts.map(u => {
            if (!u.accessCardKey) {
                return null
            }

            return {
                id: u.id,
                accessKey: u.accessCardKey,
            }
        })
    )

export const isUserAccountClockedIn = (userAccountId: string, timeRecords: TimesheetRecord[]): boolean => {
    return timeRecords.some(r => r.userAccountId === userAccountId && !r.clockOutTimestamp)
}
